import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["truncated", "full", "button"]
  }

  connect() {
    this.updateButton()
  }

  toggle() {
    if (this.fullTarget.classList.contains("d-none")) {
      this.fullTarget.classList.remove("d-none")
      this.truncatedTarget.classList.add("d-none")
    } else {
      this.fullTarget.classList.add("d-none")
      this.truncatedTarget.classList.remove("d-none")
    }

    this.updateButton()
  }

  updateButton() {
    if (this.fullTarget.classList.contains("d-none")) {
      this.buttonTarget.textContent = "more"
    } else {
      this.buttonTarget.textContent = "less"
    }
  }
}
